import { getRootAppPath, rootAppPath } from '../../routes/company-tracker/utils';
import { RouteInterfaceMin } from '../../types/routes';

const downloadsRoot = `/${rootAppPath}/downloads/:initiativeId?/custom`;
const commonRoute: RouteInterfaceMin = {
  getRootAppPath,
  path: ''
}

export const CustomReportRoutes: { [key: string]: RouteInterfaceMin } = {
  ROOT: {
    ...commonRoute,
    path: `${downloadsRoot}/manage`
  },
  CREATE_REPORT: {
    ...commonRoute,
    path: `${downloadsRoot}/create/:createType?`
  },
  MANAGE_REPORT: {
    ...commonRoute,
    path: `${downloadsRoot}/manage/:reportId`
  },
  ADD_METRIC: {
    ...commonRoute,
    path: `${downloadsRoot}/manage/:reportId/add/:metricType?`
  },
}
